/**
 * Whether an element is visible, mirroring jQuery's `:visible` pseudo-selector.
 *
 * @param {Element} element - The element to check.
 * @returns {boolean} True if the element occupies layout space.
 */
function isVisible(element) {
    const el = /** @type {HTMLElement} */ (element);

    return !!(
        el.offsetWidth ||
        el.offsetHeight ||
        element.getClientRects().length
    );
}

const header = {
    /** @type {ReturnType<typeof setTimeout> | null} */
    timer: null,

    /**
     * Bind header menu hover/leave listeners for mega-menu behaviour.
     *
     * @returns {void}
     */
    init() {
        document
            .querySelectorAll(".lux-main-menu .lux-menu-link")
            .forEach((link) => {
                link.addEventListener("mouseenter", () => {
                    const searchOverlay = document.querySelector(
                        ".search-result-overlay",
                    );
                    if (searchOverlay && isVisible(searchOverlay)) return;

                    const id = link.getAttribute("data-id");

                    header.timer = setTimeout(() => {
                        const overlay = document.querySelector(
                            ".lux-main-menu-overlay",
                        );
                        if (overlay instanceof HTMLElement) {
                            overlay.style.display = "";
                        }

                        document
                            .querySelectorAll(".lux-section-menu")
                            .forEach((section) => {
                                if (section instanceof HTMLElement) {
                                    section.style.display = "none";
                                }
                            });

                        const activeSection = document.querySelector(
                            `.lux-section-menu[data-id=${id}]`,
                        );
                        if (activeSection instanceof HTMLElement) {
                            activeSection.style.display = "grid";
                        }
                    }, 100);
                });

                link.addEventListener("mouseleave", () => {
                    if (header.timer !== null) {
                        clearTimeout(header.timer);
                    }
                });
            });

        const overlay = document.querySelector(".lux-main-menu-overlay");
        if (overlay instanceof HTMLElement) {
            const showOverlay = () => {
                overlay.style.display = "";
            };

            // jQuery's `.hover(fn)` with a single handler binds it to both
            // mouseenter and mouseleave - preserved as-is.
            overlay.addEventListener("mouseenter", showOverlay);
            overlay.addEventListener("mouseleave", showOverlay);
        }

        document
            .querySelectorAll(".lux-main-menu, .lux-main-menu-overlay")
            .forEach((el) => {
                el.addEventListener("mouseleave", () => {
                    if (overlay instanceof HTMLElement) {
                        overlay.style.display = "none";
                    }
                });
            });
    },
};
window.header = header;
header.init();

document
    .querySelectorAll(".lux-main-menu-overlay .lux-section-menu")
    .forEach((section) => {
        const dataId = section.getAttribute("data-id");

        section.addEventListener("mouseenter", () => {
            document
                .querySelectorAll(".lux-main-menu .lux-menu-link")
                .forEach((link) => {
                    if (dataId === link.getAttribute("data-id")) {
                        link.classList.add("hover");
                    }
                });
        });

        section.addEventListener("mouseleave", () => {
            document
                .querySelectorAll(".lux-main-menu .lux-menu-link")
                .forEach((link) => {
                    if (dataId === link.getAttribute("data-id")) {
                        link.classList.remove("hover");
                    }
                });
        });
    });

/**
 * Create a debounced version of a function.
 *
 * @param {() => void} fn - The function to debounce.
 * @param {number} wait - The debounce delay in milliseconds.
 * @returns {() => void} The debounced function.
 */
const debounce = (fn, wait) => {
    /** @type {ReturnType<typeof setTimeout> | undefined} */
    let timeout;
    return () => {
        clearTimeout(timeout);
        timeout = setTimeout(fn, wait);
    };
};

/** @type {string | null} */
let lastHeaderHeight = null;
/** @type {string | null} */
let lastLuxHeaderHeight = null;

/**
 * Measure and set the --headerHeight CSS custom property on the body.
 *
 * @returns {void}
 */
export const setHeaderHeight = () => {
    const header = document.querySelector("header");
    const luxHeader = document.querySelector(".lux-header");

    const headerHeight = header
        ? header.getBoundingClientRect().bottom + "px"
        : null;
    const luxHeaderHeight =
        luxHeader instanceof HTMLElement ? luxHeader.offsetHeight + "px" : null;

    if (headerHeight !== null && headerHeight !== lastHeaderHeight) {
        document.body.style.setProperty("--headerHeight", headerHeight);
        lastHeaderHeight = headerHeight;
    }

    if (luxHeaderHeight !== null && luxHeaderHeight !== lastLuxHeaderHeight) {
        document.body.style.setProperty("--luxHeaderHeight", luxHeaderHeight);
        lastLuxHeaderHeight = luxHeaderHeight;
    }
};

/** @type {number | null} */
let frame = null;

/**
 * Coalesce a burst of scroll events into at most one measurement per frame.
 *
 * @returns {void}
 */
const scheduleSetHeaderHeight = () => {
    if (frame !== null) {
        return;
    }

    frame = window.requestAnimationFrame(() => {
        frame = null;
        setHeaderHeight();
    });
};

window.addEventListener("resize", debounce(setHeaderHeight, 500));
window.addEventListener("scroll", scheduleSetHeaderHeight, { passive: true });
window.addEventListener("load", setHeaderHeight);

export default header;
